import React, { useEffect, useState } from 'react';
import { Box as MuiBox, LinearProgress } from '@mui/material';

const PROGRESS_MAX_PERCENTAGE = 100;
const PROGRESS_UPDATE_INTERVAL = 300;
const MINIMUM_DISPLAY_TIME_IN_MILLISECONDS = 1500;

export default function LoadingProgressBar({ onComplete }) {
  const [loadingProgressPercentage, setLoadingProgressPercentage] = useState(0);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    setIsActive(true);

    const timer = setInterval(() => {
      setLoadingProgressPercentage((oldProgress) => {
        if (oldProgress === PROGRESS_MAX_PERCENTAGE) {
          clearInterval(timer);
          setIsActive(false);

          if (onComplete) {
            onComplete();
          }

          return PROGRESS_MAX_PERCENTAGE;
        }

        return Math.min(oldProgress + PROGRESS_MAX_PERCENTAGE, PROGRESS_MAX_PERCENTAGE);
      });
    }, PROGRESS_UPDATE_INTERVAL);

    const minimumDisplayDurationTimer = setTimeout(() => {
      if (loadingProgressPercentage < PROGRESS_MAX_PERCENTAGE) {
        setIsActive(false);
      }
    }, MINIMUM_DISPLAY_TIME_IN_MILLISECONDS);

    return () => {
      clearInterval(timer);
      clearTimeout(minimumDisplayDurationTimer);
    };

  }, [onComplete, loadingProgressPercentage]);

  if (!isActive) {
    return null;
  }

  return (
    <MuiBox sx={{ width: '100%' }}>
      <LinearProgress variant="determinate" value={loadingProgressPercentage} />
    </MuiBox>
  );
}